export default __webpack_public_path__ + "static/media/fallbackLogo.ed0c0068.png";